import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  Menu,
  Button,
  Drawer,
  IconButton,
  useMediaQuery,
  Box,
  Typography,
  Divider,
  ListItem,
  Collapse,
  Tooltip,
  Fade,
  ClickAwayListener,
  Badge,
} from "@mui/material";
import TouchAppIcon from '@mui/icons-material/TouchApp';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { setCategories } from '../reducers/CategoriesSlice';
import { setCurrentIndexId } from '../reducers/MaskingSlice';
import AddIndexDialog from './AddIndexDialog';
import ReportsListDialog from './ReportsListDialog';
import UserGuideDialog from './UserGuideDialog';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { url } from "../api/axios_client";
import { toast } from "react-toastify";
import useApi from "../hooks/useApi";
import { useAdmin } from '../hooks/useAdmin';
import axios from "../api/axios_client";
import {
  addIndex,
  getCategories
} from "../api/FlaskAPI";
import {
  clearAreas,
  setUploaderFlag,
} from "../reducers/MapSlice";
// import './NavPageSelector.css';
import './NavPageStyle.css';
import SignComponent from "./Sign/SignComponent";
import LanguageSwitcher from "./LanguageSwitcher";
import LanguageIcon from "@mui/icons-material/Language";
import usericon from "../assets/images/user-icon.png";
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';
import QueueOutlinedIcon from '@mui/icons-material/QueueOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { DesktopIndexMenu } from './DesktopIndexMenu'




export default function NavPageSelector() {
  const navigate = useNavigate();
  const isAdmin = useAdmin();
  const dispatch = useDispatch();
  const categoriesFecth = useApi(getCategories);
  const indexes = useApi(addIndex)
  const [loading, setloading] = useState(false);
  const categories = useSelector((state) => state.categories);
  const [selectedItems, setSelectedItems] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [subAnchorEl, setSubAnchorEl] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [currentType, setCurrentType] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [userGuideDialogOpen, setUserGuideDialogOpen] = useState(false);
  const [newIndexType, setNewIndexType] = useState(null);
  const areas = useSelector((state) => state.mapState.areas);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [expandedType, setExpandedType] = useState({});

  // Mobile onboarding state
  const [showGuideHint, setShowGuideHint] = useState(false);
  const [showDrawerGuideHighlight, setShowDrawerGuideHighlight] = useState(false);

  // Media query for responsive behavior
  const isMobile = useMediaQuery('(max-width:800px)');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [toolsAnchorEl, setToolsAnchorEl] = useState(null);
  const selectedCategoryRef = useRef(null);
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  const open = Boolean(anchorEl);

  useEffect(() => {
    const storedCategories = localStorage.getItem('categories');
    if (storedCategories) {
      dispatch(setCategories(JSON.parse(storedCategories)));
    }

    const storedSelectedItems = localStorage.getItem('selectedItems');
    if (storedSelectedItems) {
      setSelectedItems(JSON.parse(storedSelectedItems));
    }

  }, [dispatch]);

  // Show guide hint on first visit (both mobile and desktop)
  useEffect(() => {
    const hasSeenGuideHint = localStorage.getItem('hasSeenGuideHint');
    if (!hasSeenGuideHint) {
      // Delay showing the hint for a smoother experience
      const timer = setTimeout(() => {
        setShowGuideHint(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  // When drawer opens and hint was showing, highlight the guide button
  useEffect(() => {
    if (drawerOpen && showGuideHint) {
      setShowGuideHint(false);
      setShowDrawerGuideHighlight(true);
      localStorage.setItem('hasSeenGuideHint', 'true');
    }
  }, [drawerOpen, showGuideHint]);

  const dismissGuideHint = () => {
    setShowGuideHint(false);
    localStorage.setItem('hasSeenGuideHint', 'true');
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getMenuProps = (menuType) => {
    const isMobile = windowWidth <= 768;

    if (isMobile) {
      return {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center',
        }
      };
    }

    // Desktop positioning
    switch (menuType) {
      case 'tools':
        return {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
          }
        };
      case 'sub':
        return {
          anchorOrigin: { vertical: 'bottom', horizontal: isArabic ? 'left' : 'right' },
          transformOrigin: { vertical: 'top', horizontal: isArabic ? 'right' : 'left' }
        };
      case 'third':
        return {
          anchorOrigin: { vertical: 'top', horizontal: isArabic ? 'left' : 'right' },
          transformOrigin: { vertical: 'top', horizontal: isArabic ? 'right' : 'left' }
        };
      default:
        return {
          anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
          transformOrigin: { vertical: 'top', horizontal: 'center' }
        };
    }
  };

  // useEffect(() => {
  //   if (categories.data) {
  //     localStorage.setItem('categories', JSON.stringify(categories.data));
  //   }
  // }, [categories]);
  if (!categories || !Array.isArray(categories) || !categories.length) {
    console.log("categories:", categories);
    return <div>Loading categories...</div>;
  }

  const groupedCategories = categories.reduce((acc, category) => {
    const { category: catName, type, name, id } = category;
    if (!acc[catName]) {
      acc[catName] = {};
    }
    if (!acc[catName][type]) {
      acc[catName][type] = [];
    }
    acc[catName][type].push({ label: name, id });
    return acc;
  }, {});
  const groupedCategoriesLabels = categories.reduce((acc, category) => {
    const { category: catName, category_ar, type, type_ar, name, name_ar, id } = category;
    if (!acc[catName]) {
      acc[catName] = {};
      acc[catName]['name'] = isArabic ? category_ar : catName;
    }
    if (!acc[catName]["types"]) {
      acc[catName]["types"] = {};
    }
    if (!acc[catName]["types"][type]) {
      acc[catName]['types'][type] = {};
      acc[catName]['types'][type]['options'] = [];
      acc[catName]['types'][type]['name'] = isArabic ? type_ar : type;
    }
    acc[catName]['types'][type]['options'].push({ label: name, label_ar: name_ar, id });
    return acc;
  }, {});

  const getSelectedLabel = () => {
    if (selectedItems.currentCategory === 'Tools' && selectedItems.Tools) {
      return t(`Map.${selectedItems.Tools.toLowerCase()}`);
    }

    if (
      selectedItems.currentCategory &&
      selectedItems.currentType &&
      groupedCategoriesLabels[selectedItems.currentCategory]?.types?.[selectedItems.currentType]?.options?.length > 0
    ) {
      const selectedOption = groupedCategoriesLabels[selectedItems.currentCategory].types[selectedItems.currentType].options.find(
        option => option.id === localStorage.getItem('currentIndexId') || option.label === selectedItems[selectedItems.currentCategory]
      );

      if (selectedOption) {
        return selectedOption[isArabic ? 'label_ar' : 'label'];
      }
    }

    // Default fallback
    return t('Map.select_index');
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleCategoryExpand = (category) => {
    setExpandedCategory(expandedCategory === category ? null : category);
    // Reset expanded types when changing category
    if (expandedCategory !== category) {
      setExpandedType({});
    }
  };

  const handleTypeExpand = (category, type) => {
    setExpandedType(prev => ({
      ...prev,
      [category]: prev[category] === type ? null : type
    }));
  };

  const handleDrawerItemClick = (category, type, label, id) => {
    const newSelectedItems = {
      ...selectedItems
    };

    if (category === "Tools") {
      // For Tools menu selections
      newSelectedItems.Tools = label;
      newSelectedItems.currentCategory = category;
    } else {
      // For regular index selections
      newSelectedItems[category] = label;
      newSelectedItems.currentCategory = category;
      newSelectedItems.currentType = type;
    }

    setSelectedItems(newSelectedItems);
    localStorage.setItem('selectedItems', JSON.stringify(newSelectedItems));

    if (id) {
      dispatch(setCurrentIndexId(id));
      localStorage.setItem('currentIndexId', id);
    }

    setDrawerOpen(false);

    // Handle navigation based on selection
    if (category === "Tools") {
      // Handle Tools navigation
      switch (label) {
        case "Prediction":
          // localStorage.removeItem("mapFileContent");
          // dispatch(clearAreas(areas));
          // dispatch(setUploaderFlag(false));
          navigate('/prediction');
          break;
        case "Monitoring":
          navigate('/monitoring');
          break;
        case "Reporting":
          navigate('/reporting');
          break;
        case "Land Degradation":
          // localStorage.removeItem("mapFileContent");
          // dispatch(clearAreas(areas));
          // dispatch(setUploaderFlag(false));
          navigate('/land-degradation');
          break;
      }
    } else if (category === "Prediction" || category === "Monitoring" ||
      category === "Reporting" || category === "Land Degradation") {
      // Handle special categories
      // if (category === "Prediction" || category === "Land Degradation") {
      //   // localStorage.removeItem("mapFileContent");
      //   dispatch(clearAreas(areas));
      //   dispatch(setUploaderFlag(false));
      // }
      navigate(`/${category.replace(/\s+/g, '-').toLowerCase()}`);
    } else if (category && type && label) {
      // Handle regular index navigation
      navigate(`/${category.replace(/\s+/g, '-').toLowerCase()}/${type.toLowerCase()}/${label.toLowerCase()}`);
    }
  };

  const handleClickListItem = (event, category) => {
    event.preventDefault();
    event.stopPropagation();
    setCurrentCategory(category);
  };

  const handleTypeClick = (event, type) => {
    event.preventDefault();
    event.stopPropagation();
    setCurrentType(type);
    setSubAnchorEl(event.currentTarget);
    setSelectedItems(prev => ({ ...prev, currentType: type }));
  };

  // In the Tools Menu section
  <Menu
    anchorEl={toolsAnchorEl}
    open={Boolean(toolsAnchorEl)}
    onClose={() => {
      setToolsAnchorEl(null);
      setCurrentCategory(null);
    }}
    className="tools-menu"
    keepMounted
    {...getMenuProps('tools')}
  >
    <MenuItem onClick={(event) => handleMenuItemClick(event, "Tools", null, "Prediction")}>
      Prediction
    </MenuItem>
    <MenuItem onClick={(event) => handleMenuItemClick(event, "Tools", null, "Monitoring")}>
      Monitoring
    </MenuItem>
    <MenuItem onClick={(event) => handleMenuItemClick(event, "Tools", null, "Reporting")}>
      Reporting
    </MenuItem>
    <MenuItem onClick={(event) => handleMenuItemClick(event, "Tools", null, "Land Degradation")}>
      Land Degradation
    </MenuItem>
  </Menu>

  // Update handleMenuItemClick function
  const handleMenuItemClick = (event, category, type, label, id) => {
    event.preventDefault();
    event.stopPropagation();

    if (category === "Tools") {
      const toolsSelection = {
        Tools: label,
        toolsCategory: "Tools"
      };
      // Only update the Tools selection
      setSelectedItems(prev => ({
        ...prev,
        ...toolsSelection
      }));
      localStorage.setItem('selectedItems', JSON.stringify(toolsSelection));


      // Handle Tools navigation
      switch (label) {
        case "Prediction":
          // localStorage.removeItem("mapFileContent");
          // dispatch(clearAreas(areas));
          // dispatch(setUploaderFlag(false));
          navigate('/prediction');
          break;
        case "Monitoring":
          navigate('/monitoring');
          break;
        case "Reporting":
          navigate('/reporting');
          break;
        case "Land Degradation":
          // localStorage.removeItem("mapFileContent");
          // dispatch(clearAreas(areas));
          // dispatch(setUploaderFlag(false));
          navigate('/land-degradation');
          break;
      }
    } else {
      // Handle main index menu
      const newSelectedItems = {
        ...selectedItems,
        currentCategory: category,
        currentType: type,
        [category]: label,
        // Remove any Tools selection
        Tools: undefined
      };
      setSelectedItems(newSelectedItems);
      localStorage.setItem('selectedItems', JSON.stringify(newSelectedItems));

      if (id) {
        dispatch(setCurrentIndexId(id));
        localStorage.setItem('currentIndexId', id);
      }

      if (category && type && label) {
        navigate(`/${category.replace(/\s+/g, '-').toLowerCase()}/${type.toLowerCase()}/${label.toLowerCase()}`);
      }
    }

    // Close all menus
    setAnchorEl(null);
    setToolsAnchorEl(null);
    setSubAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setToolsAnchorEl(null);
    setCurrentCategory(null);
    setCurrentType(null);
  };

  const handleAddIndex = async (newIndex) => {
    console.log("New Index Added:", newIndex);
    const toastId = toast.loading("Adding Index...");
    try {
      const res = await axios.post(`${url}/indexes`, newIndex, {
        headers: {
          "Content-Type": "application/json"
        },
      });
      if (res.status === 201) {
        console.log("res", res);
        const result = res;
        if (result && result.data) {
          const res = await categoriesFecth.request({
            index: "ndvi"
          });
          dispatch(setCategories(res.data));
          localStorage.setItem('categories', JSON.stringify(res.data));
          toast.update(toastId, {
            render: "Index Added Successfully",
            type: "success",
            isLoading: false,
            autoClose: 2000
          });
          setDialogOpen(false);
        } else {
          toast.update(toastId, {
            render: "Something Went Wrong",
            type: "error",
            isLoading: false,
            autoClose: 2000
          });
          throw new Error("Something Went Wrong");
        }
      }
    } catch (error) {
      let errMsg = error.response?.data?.message;
      toast.update(toastId, {
        render: (errMsg && errMsg !== '') ? errMsg : "something went wrong",
        type: "error",
        isLoading: false,
        autoClose: 2000
      });
      console.log(error);
      throw error;
    } finally {
      setloading(false);
    }
  };

  // Drawer content
  const drawerContent = (
    <Box
      sx={{ width: 280 }}
      role="presentation"
    >
      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
        <SignComponent drawer={true} />
        <LanguageSwitcher drawer={true} />
      </Box>
      <Box sx={{ p: 2, backgroundColor: 'white' }}>
        <Typography variant="h6">{t('Map.select_index')}</Typography>
      </Box>
      <Divider />
      <List>
        {Object.keys(groupedCategories).map((category) => (
          <React.Fragment key={category}>
            <ListItemButton onClick={() => handleCategoryExpand(category)}>
              <ListItemText primary={groupedCategoriesLabels[category]['name']} sx={{
                textAlign: isArabic ? 'right' : 'left',
              }} />
              {expandedCategory === category ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={expandedCategory === category} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {Object.keys(groupedCategories[category]).map((type) => (
                  <React.Fragment key={type}>
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => handleTypeExpand(category, type)}
                    >
                      <ListItemText primary={groupedCategoriesLabels[category]['types'][type]['name']} sx={{
                        textAlign: isArabic ? 'right' : 'left',
                      }} />
                      {expandedType[category] === type ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={expandedType[category] === type} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {groupedCategories[category][type].map((option, index) => (
                          <ListItemButton
                            key={option.id}
                            sx={{ pl: 6 }}
                            selected={selectedItems[category] === option.label}
                            onClick={() => handleDrawerItemClick(category, type, option.label, option.id)}
                          >
                            <ListItemText primary={groupedCategoriesLabels[category]['types'][type]['options'][index][isArabic ? 'label_ar' : 'label']} sx={{
                              textAlign: isArabic ? 'right' : 'left',
                            }} />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  </React.Fragment>
                ))}
              </List>
            </Collapse>
          </React.Fragment>
        ))}
      </List>
      {/* {isAdmin && (
        <>

      <Box sx={{ p: 2, backgroundColor: 'white' }}>
        <Typography variant="h6">{t('Map.select_tool')}</Typography>
      </Box>
      <Divider />
      <List>
      
          <ListItemButton onClick={() => handleCategoryExpand("Tools")}>
            <ListItemText primary={t('Map.tools')} sx={{
              textAlign: isArabic ? 'right' : 'left',
            }}/>
            {expandedCategory === "Tools" ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={expandedCategory === "Tools"} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton 
                sx={{ pl: 4 }}
                selected={selectedItems.Tools === "Prediction"}
                onClick={() => handleDrawerItemClick("Tools", "tools", "Prediction")}
              >
                <ListItemText primary={t('Map.prediction')} sx={{
                textAlign: isArabic ? 'right' : 'left',
              }}/>
              </ListItemButton>
              <ListItemButton 
                sx={{ pl: 4 }}
                selected={selectedItems.Tools === "Monitoring"}
                onClick={() => handleDrawerItemClick("Tools", "tools", "Monitoring")}
              >
                <ListItemText primary={t('Map.monitoring')} sx={{
                textAlign: isArabic ? 'right' : 'left',
              }}/>
              </ListItemButton>
              <ListItemButton 
                sx={{ pl: 4 }}
                selected={selectedItems.Tools === "Reporting"}
                onClick={() => handleDrawerItemClick("Tools", "tools", "Reporting")}
              >
                <ListItemText primary={t('Map.reporting')} sx={{
                textAlign: isArabic ? 'right' : 'left',
              }}/>
              </ListItemButton>
              <ListItemButton 
                sx={{ pl: 4 }}
                selected={selectedItems.Tools === "Land Degradation"}
                onClick={() => handleDrawerItemClick("Tools", "tools", "Land Degradation")}
              >
                <ListItemText primary={t('Map.land_degradation')} sx={{
                textAlign: isArabic ? 'right' : 'left',
              }} />
              </ListItemButton>
            </List>
          </Collapse>
    </List>
    </>
      )} */}

      <Divider />

      {/* Admin buttons in drawer */}
      {isAdmin && (
        <ListItem>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => {
              setDialogOpen(true);
              setDrawerOpen(false);
            }}
          >
            {t('Map.add_index')}
          </Button>
        </ListItem>
      )}
      <ListItem>
        <Button
          fullWidth
          variant="outlined"
          onClick={() => {
            setReportsDialogOpen(true);
            setDrawerOpen(false);
          }}
        >
          {t('Map.view_reports')}
        </Button>
      </ListItem>
      <ListItem>
        <Button
          fullWidth
          variant={showDrawerGuideHighlight ? "contained" : "outlined"}
          onClick={() => {
            setUserGuideDialogOpen(true);
            setDrawerOpen(false);
            setShowDrawerGuideHighlight(false);
          }}
          sx={showDrawerGuideHighlight ? {
            backgroundColor: "#339ace",
            color: "white",
            animation: "pulseGuide 1.5s ease-in-out infinite",
            "@keyframes pulseGuide": {
              "0%": {
                boxShadow: "0 0 0 0 rgba(255, 193, 7, 0.8)",
                transform: "scale(1)",
              },
              "50%": {
                boxShadow: "0 0 20px 8px rgba(255, 193, 7, 0.5)",
                transform: "scale(1.02)",
              },
              "100%": {
                boxShadow: "0 0 0 0 rgba(255, 193, 7, 0)",
                transform: "scale(1)",
              },
            },
            "&:hover": {
              backgroundColor: "#2a7ba8",
            },
          } : {}}
        >
          {showDrawerGuideHighlight && <TouchAppIcon sx={{ mr: 1 }} />}
          {t('UserGuide.button')}
        </Button>
      </ListItem>
    </Box>
  );

  return (
    <div className="navbar-selection-container">
      {isMobile ? (
        /* Mobile View - Drawer */
        <>
          <div className="mobile-header">
            <ClickAwayListener onClickAway={() => showGuideHint && dismissGuideHint()}>
              <Tooltip
                open={showGuideHint}
                title={
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    p: 0.5,
                  }}>
                    <TouchAppIcon sx={{ fontSize: 20 }} />
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {t('UserGuide.mobile_hint')}
                    </Typography>
                  </Box>
                }
                arrow
                placement={isArabic ? "bottom-end" : "bottom-start"}
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 300 }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: '#339ace',
                      color: 'white',
                      fontSize: '0.875rem',
                      py: 1.5,
                      px: 2,
                      borderRadius: '10px',
                      boxShadow: '0 4px 20px rgba(51, 154, 206, 0.4)',
                      animation: 'bounceTooltip 0.5s ease-out',
                      '@keyframes bounceTooltip': {
                        '0%': { opacity: 0, transform: 'scale(0.8) translateY(-10px)' },
                        '50%': { transform: 'scale(1.05) translateY(0)' },
                        '100%': { opacity: 1, transform: 'scale(1) translateY(0)' },
                      },
                    },
                  },
                  arrow: {
                    sx: {
                      color: '#339ace',
                    },
                  },
                }}
              >
                <Badge
                  color="warning"
                  variant="dot"
                  invisible={!showGuideHint}
                  sx={{
                    '& .MuiBadge-badge': {
                      animation: showGuideHint ? 'pulseDot 1s ease-in-out infinite' : 'none',
                      '@keyframes pulseDot': {
                        '0%': { transform: 'scale(1)' },
                        '50%': { transform: 'scale(1.5)' },
                        '100%': { transform: 'scale(1)' },
                      },
                    },
                  }}
                >
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    onClick={toggleDrawer(true)}
                    sx={showGuideHint ? {
                      animation: 'pulseButton 1.5s ease-in-out infinite',
                      '@keyframes pulseButton': {
                        '0%': { boxShadow: '0 0 0 0 rgba(255, 193, 7, 0.7)' },
                        '50%': { boxShadow: '0 0 15px 5px rgba(255, 193, 7, 0.4)' },
                        '100%': { boxShadow: '0 0 0 0 rgba(255, 193, 7, 0)' },
                      },
                    } : {}}
                  >
                    <MenuIcon />
                  </IconButton>
                </Badge>
              </Tooltip>
            </ClickAwayListener>
            <div className="selected-info">
              <div className="selected-category">
                {selectedItems.currentCategory ? selectedItems.currentCategory === 'Tools' ? t('Map.tools') : groupedCategoriesLabels[selectedItems.currentCategory]['name']?.toUpperCase() : t('Map.select_index')}
              </div>
              {selectedItems[selectedItems.currentCategory] && (
                <div className="selected-index">
                  {getSelectedLabel()}
                </div>
              )}
            </div>
            <div className="mobile-icons">
              <LanguageIcon sx={{ width: "1.2em", height: "1.2em" }} onClick={toggleDrawer(true)} />
              <IconButton sx={{ padding: 0 }} onClick={toggleDrawer(true)}>
                <AccountCircleOutlinedIcon sx={{ width: "1.2em", height: "1.2em", color: "black" }} />
              </IconButton>
            </div>
          </div>

          <Drawer
            anchor={isArabic ? 'right' : 'left'}
            open={drawerOpen}
            onClose={toggleDrawer(false)}
          >
            {drawerContent}
          </Drawer>
        </>
      ) : (
        /* Desktop View - Dropdown Menus */
        <>
          {/* Hierarchical Menus */}
          <DesktopIndexMenu
            groupedCategoriesLabels={groupedCategoriesLabels}
            groupedCategories={groupedCategories}
            selectedItems={selectedItems}
            handleMenuItemClick={handleMenuItemClick}
            t={t}
            isArabic={isArabic}
            getSelectedLabel={getSelectedLabel}
          />

          {isAdmin && (
            <Button
              onClick={(event) => {
                setToolsAnchorEl(event.currentTarget);
                setAnchorEl(null);
              }}
              sx={{
                color: "black",
                border: "1px solid #339ace",
                borderRadius: "15px",
                padding: "7px 15px",
                backgroundColor: "white"
              }}
            >
              <div className="button-content">
                <div className="selected-category">{t('Map.tools')} | </div>
                <div className="selected-index">
                  {selectedItems.Tools ? t(`Map.${selectedItems.Tools.toLowerCase()}`) : t('Map.select_tool')} <BrushOutlinedIcon />
                </div>
              </div>
            </Button>
          )}

          {/* Tools Menu */}
          <Menu
            anchorEl={toolsAnchorEl}
            open={Boolean(toolsAnchorEl)}
            onClose={() => {
              setToolsAnchorEl(null);
              setCurrentCategory(null);
            }}
            className="tools-menu"
            keepMounted
            {...getMenuProps('tools')}
          >
            <MenuItem onClick={(event) => handleMenuItemClick(event, "Tools", "tools", "Prediction")}>
              {t('Map.prediction')}
            </MenuItem>
            <MenuItem onClick={(event) => handleMenuItemClick(event, "Tools", "tools", "Monitoring")}>
              {t('Map.monitoring')}
            </MenuItem>
            <MenuItem onClick={(event) => handleMenuItemClick(event, "Tools", "tools", "Reporting")}>
              {t('Map.reporting')}
            </MenuItem>
            <MenuItem onClick={(event) => handleMenuItemClick(event, "Tools", "tools", "Land Degradation",)}>
              {t('Map.land_degradation')}
            </MenuItem>
          </Menu>




          <div className="admin-buttons">
            {isAdmin && (
              <Button
                onClick={() => setDialogOpen(true)}

                sx={{
                  color: "white",
                  backgroundColor: "#339ace",
                  borderRadius: "15px",
                  padding: "7px 15px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  "&:hover": {
                    backgroundColor: "#339ace",
                  },
                }}
              >
                {t('Map.add_index')}<QueueOutlinedIcon />
              </Button>
            )}

            <Button
              onClick={() => setReportsDialogOpen(true)}
              sx={{
                color: "white",
                backgroundColor: "#339ace",
                borderRadius: "15px",
                padding: "7px 15px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                "&:hover": {
                  backgroundColor: "#339ace",
                },
              }}
            >
              {t('Map.view_reports')} <AssessmentOutlinedIcon />
            </Button>

            <ClickAwayListener onClickAway={() => !isMobile && showGuideHint && dismissGuideHint()}>
              <Tooltip
                open={!isMobile && showGuideHint}
                title={
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    p: 0.5,
                  }}>
                    <TouchAppIcon sx={{ fontSize: 20 }} />
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {t('UserGuide.desktop_hint')}
                    </Typography>
                  </Box>
                }
                arrow
                placement="bottom"
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 300 }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: '#339ace',
                      color: 'white',
                      fontSize: '0.875rem',
                      py: 1.5,
                      px: 2,
                      borderRadius: '10px',
                      boxShadow: '0 4px 20px rgba(51, 154, 206, 0.4)',
                      animation: 'bounceTooltip 0.5s ease-out',
                      '@keyframes bounceTooltip': {
                        '0%': { opacity: 0, transform: 'scale(0.8) translateY(-10px)' },
                        '50%': { transform: 'scale(1.05) translateY(0)' },
                        '100%': { opacity: 1, transform: 'scale(1) translateY(0)' },
                      },
                    },
                  },
                  arrow: {
                    sx: {
                      color: '#339ace',
                    },
                  },
                }}
              >
                <Button
                  onClick={() => {
                    setUserGuideDialogOpen(true);
                    setShowGuideHint(false);
                    localStorage.setItem('hasSeenGuideHint', 'true');
                  }}
                  sx={{
                    color: "white",
                    backgroundColor: "#339ace",
                    borderRadius: "15px",
                    padding: "7px 15px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    position: "relative",
                    overflow: "hidden",
                    animation: "pulseGlow 2s ease-in-out 3",
                    "@keyframes pulseGlow": {
                      "0%": {
                        boxShadow: "0 0 0 0 rgba(255, 193, 7, 0.8)",
                      },
                      "50%": {
                        boxShadow: "0 0 25px 8px rgba(255, 193, 7, 0.6)",
                      },
                      "100%": {
                        boxShadow: "0 0 0 0 rgba(255, 193, 7, 0)",
                      },
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: "-100%",
                      width: "100%",
                      height: "100%",
                      background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)",
                      animation: "shimmer 2s ease-in-out 3",
                    },
                    "@keyframes shimmer": {
                      "0%": {
                        left: "-100%",
                      },
                      "100%": {
                        left: "100%",
                      },
                    },
                    "&:hover": {
                      backgroundColor: "#2a7ba8",
                    },
                  }}
                >
                  {t('UserGuide.button')} <MenuBookOutlinedIcon />
                </Button>
              </Tooltip>
            </ClickAwayListener>
          </div>
        </>
      )}

      <AddIndexDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onAdd={handleAddIndex}
        newIndexType={newIndexType}
      />

      <ReportsListDialog
        open={reportsDialogOpen}
        onClose={() => setReportsDialogOpen(false)}
      />

      <UserGuideDialog
        open={userGuideDialogOpen}
        onClose={() => setUserGuideDialogOpen(false)}
      />
    </div>
  );
}